@if (navigatorOpened()) {
<app-interactive-navigator
  [navDefinition]="navigatorItems"
  [isClosable]="true"
  [showHeader]="false"
  (oncloseNav)="navigatorOpened.set(false)" />
} @if (!navigatorOpened()) {
<div class="h-full flex flex-col overflow-hidden">
  <!-- ACTION BUTTONS -->
  <!-- @if (isRowSelected() && currentButtons()) { -->
  <div class="shrink-0">
    <div class="flex-1 hidden lg:block">
      <app-status-bar />
    </div>
    <h1
      [class]="isDarkMode() ? 'text-emerald-50' : 'text-emerald-800'"
      class="text-2xl m-2 font-bold underline">
      Pacientes
    </h1>
  </div>

  <!-- Vigilancia filter: server-side boolean filter layered on top of the grid filters -->
  <section
    class="mb-4 shrink-0 rounded-xl border p-4 shadow-sm transition-colors"
    [class]="isDarkMode() ? 'bg-zinc-800/60 border-zinc-700' : 'bg-white border-gray-200'"
    aria-label="Filtros de pacientes">
    <div class="flex flex-col gap-4 lg:flex-row lg:items-center lg:gap-6">
      <div class="flex flex-wrap items-center gap-3 lg:shrink-0">
        <p-togglebutton
          [ngModel]="investigacionEpidemiologica()"
          (onChange)="onInvestigacionToggle($event.checked)"
          [ngModelOptions]="{ standalone: true }"
          onLabel="Investigación Epidemiológica de Campo"
          offLabel="Investigación Epidemiológica de Campo"
          onIcon="pi pi-users"
          offIcon="pi pi-users"
          inputId="toggle-investigacion"
          ariaLabel="Investigación Epidemiológica de Campo"
          data-testid="toggle-investigacion-epidemiologica" />
        <p-togglebutton
          [ngModel]="georreferenciacionFilter()"
          (onChange)="onGeorreferenciacionToggle($event.checked)"
          [ngModelOptions]="{ standalone: true }"
          onLabel="Pacientes con Georreferenciación"
          offLabel="Pacientes con Georreferenciación"
          onIcon="pi pi-globe"
          offIcon="pi pi-globe"
          inputId="toggle-georreferenciacion"
          ariaLabel="Pacientes con Georreferenciación"
          data-testid="georreferenciacion-filter-toggle" />
        <p-togglebutton
          [ngModel]="pacientesEgresadosFilter()"
          (onChange)="onPacientesEgresadosToggle($event.checked)"
          [ngModelOptions]="{ standalone: true }"
          onLabel="Pacientes Egresados"
          offLabel="Pacientes Egresados"
          onIcon="pi pi-sign-out"
          offIcon="pi pi-sign-out"
          inputId="toggle-pacientes-egresados"
          ariaLabel="Pacientes Egresados"
          data-testid="pacientes-egresados-filter-toggle" />
      </div>

      @if (anyToggleActive()) {
      <div
        class="flex flex-col gap-2 rounded-lg border-l-4 px-4 py-3 lg:flex-1"
        [class]="isDarkMode()
          ? 'bg-zinc-900/50 border-emerald-500'
          : 'bg-emerald-50 border-emerald-500'"
        role="status"
        aria-live="polite"
        data-testid="vigilancia-mostrando">
        <span
          class="text-xs font-semibold uppercase tracking-wider"
          [class]="isDarkMode() ? 'text-emerald-300' : 'text-emerald-700'">
          Mostrando:
        </span>
        @if (investigacionEpidemiologica()) {
        <p
          class="text-sm"
          [class]="isDarkMode() ? 'text-neutral-200' : 'text-gray-700'">
          Pacientes de Tuberculosis Sensible y Tuberculosis Farmacorresistente con contactos
          registrados
        </p>
        } @if (georreferenciacionFilter()) {
        <p
          class="text-sm"
          [class]="isDarkMode() ? 'text-neutral-200' : 'text-gray-700'"
          data-testid="georreferenciacion-mostrando">
          Pacientes de Tuberculosis Sensible y Tuberculosis Farmacorresistente con
          georreferenciación registrada
        </p>
        } @if (pacientesEgresadosFilter()) {
        <p
          class="text-sm"
          [class]="isDarkMode() ? 'text-neutral-200' : 'text-gray-700'"
          data-testid="pacientes-egresados-mostrando">
          Pacientes con egreso registrado
        </p>
        }
      </div>
      }
    </div>
  </section>

  @if (isRowSelected() && currentButtons()) {
  <div class="flex shrink-0">
    <div
      data-testid="pacientes-selected-panel"
      class="flex flex-1 flex-col mb-4 gap-3 p-3 rounded-lg border relative"
      [class]="isDarkMode() ? 'bg-zinc-800 border-zinc-700' : 'bg-gray-50 border-gray-200'">
      <!-- Close button -->
      <p-button
        icon="pi pi-times"
        [rounded]="true"
        [text]="true"
        severity="secondary"
        size="small"
        pTooltip="Cerrar"
        tooltipPosition="left"
        class="!absolute top-2 right-2"
        (onClick)="clearGridSelection()" />
      <!-- Selected Patient -->
      <div class="flex items-center gap-2 min-w-0">
        <i class="pi pi-user shrink-0" [class]="isDarkMode() ? 'text-emerald-400' : 'text-emerald-600'"></i>
        <span class="font-semibold truncate" [class]="isDarkMode() ? 'text-neutral-200' : 'text-gray-800'">
          {{ selectedRow()?.nombre_completo }}
        </span>
      </div>
      <!-- Acciones -->
      <div class="flex flex-wrap gap-2">
        @for (button of currentButtons()!.top_buttons; track button.label) {
        <p-button
          [icon]="button.icon"
          [label]="button.label"
          [severity]="button.severity ?? 'secondary'"
          size="small"
          [pTooltip]="button.label"
          tooltipPosition="top"
          (onClick)="handleButtonClick(button)" />
        }
      </div>
      <p-divider styleClass="!my-0" />
      <!-- Navegación -->
      <div class="flex flex-wrap gap-2">
        @for (button of currentButtons()!.bottom_buttons; track button.label) {
        <p-button
          [icon]="button.icon"
          [label]="button.label"
          [severity]="button.severity ?? 'secondary'"
          outlined
          size="small"
          [pTooltip]="button.label"
          tooltipPosition="top"
          (onClick)="handleButtonClick(button)" />
        }
      </div>
    </div>
  </div>
  } @else {
  <!-- <app-status-bar /> -->
  }
  <!-- } -->
  <div class="flex flex-col flex-1 min-h-0">
    <div class="mb-2 shrink-0">
      @if (perm.hasPermission('sh_crear_paciente')) {
      <div class="flex justify-end">
        <p-button
          severity="secondary"
          type="button"
          icon="pi pi-user-plus"
          label="Agregar Paciente"
          data-testid="agregar-paciente-button"
          (onClick)="navigatorOpened.set(true)" />
      </div>
      }
      <p-popover #op>
        <div class="flex flex-col gap-4">
          <div>
            <ul class="list-none p-0 m-0 flex flex-col gap-3">
              <li class="hover:border-b-1 hover:border-teal-800 w-full">
                <a routerLink="crear-paciente-tbs" class="h-full w-full block">
                  <i class="pi pi-chevron-right" style="font-size: 0.7rem"></i
                  ><span class="ml-2">Tuberculosis Sensible</span>
                </a>
              </li>
              <li class="hover:border-b-1 hover:border-teal-800">
                <a routerLink="crear-tbs" class="h-full w-full block">
                  <i class="pi pi-chevron-right" style="font-size: 0.7rem"></i
                  ><span class="ml-2">Tuberculosis Farmacorresistente</span>
                </a>
              </li>
              <li class="hover:border-b-1 hover:border-teal-800">
                <a routerLink="crear-tbs" class="h-full w-full block">
                  <i class="pi pi-chevron-right" style="font-size: 0.7rem"></i
                  ><span class="ml-2">Quimioprofilaxis</span>
                </a>
              </li>
              <li class="hover:border-b-1 hover:border-teal-800">
                <a routerLink="crear-tbs" class="h-full w-full block">
                  <i class="pi pi-chevron-right" style="font-size: 0.7rem"></i><span class="ml-2">Lepra</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </p-popover>
    </div>
    @if (hasActiveFilters()) {
    <div
      class="flex flex-wrap items-center gap-2 px-3 py-2 mb-2 shrink-0 rounded-lg border-l-4"
      [class]="isDarkMode()
        ? 'bg-zinc-800/60 border-emerald-500 text-neutral-200'
        : 'bg-emerald-50 border-emerald-500 text-gray-700'"
      role="region"
      aria-label="Filtros y ordenamientos activos">
      <i
        class="pi pi-filter text-sm shrink-0"
        [class]="isDarkMode() ? 'text-emerald-400' : 'text-emerald-600'"></i>
      <span
        class="text-xs font-semibold uppercase tracking-wider shrink-0 mr-1"
        [class]="isDarkMode() ? 'text-neutral-400' : 'text-gray-500'">
        Filtros activos
      </span>
      @for (chip of activeChips(); track chip.id) {
      <p-chip
        [label]="chip.label"
        [removable]="true"
        (onRemove)="removeChip(chip)"
        styleClass="text-xs" />
      }
      <p-button
        icon="pi pi-filter-slash"
        label="Limpiar todo"
        [text]="true"
        severity="danger"
        size="small"
        class="ml-auto"
        ariaLabel="Limpiar todos los filtros y ordenamientos"
        (onClick)="clearAllFilters()" />
    </div>
    }
    <div class="flex-1 min-h-0">
      <ag-grid-angular
        data-testid="pacientes-grid"
        class="h-full w-full"
        (gridReady)="onGridReady($event)"
        (rowClicked)="onRowClicked($event)"
        (filterChanged)="onFilterChanged()"
        (sortChanged)="onSortChanged()"
        [animateRows]="true"
        [suppressRowClickSelection]="false"
        rowModelType="infinite"
        [gridOptions]="gridOptions()"
        [suppressCellFocus]="true">
      </ag-grid-angular>
    </div>
  </div>
</div>
}

<app-action-overlay
  [state]="pacientesViewService.downloadState()"
  [errorMessage]="pacientesViewService.downloadError()"
  loadingLabel="Descargando reporte..."
  loadingSublabel="Esto puede tomar unos segundos"
  successLabel="Reporte descargado exitosamente"
  errorLabel="Error al descargar el reporte"
  (dismiss)="pacientesViewService.dismissDownload()" />

<app-action-overlay
  [state]="pacientesViewService.deleteState()"
  [errorMessage]="pacientesViewService.deleteError()"
  loadingLabel="Eliminando paciente..."
  loadingSublabel="Esto puede tomar unos segundos"
  successLabel="Paciente eliminado exitosamente"
  errorLabel="Error al eliminar el paciente"
  (close)="pacientesViewService.dismissDelete()" />

<p-confirmDialog />
